import React from "react";
import "./styles.css";

const Dialog = ({ setAction, showDialog, dialogContent }) => {
  return (
    <div className={showDialog ? "dialog-box" : "dialog-box-hidden"}>
      <p>{dialogContent}</p>
      <div className="btns">
        <button onClick={() => setAction("deposit")}>Deposit</button>
        <button onClick={() => setAction("withdraw")}>Withdraw</button>
        <button onClick={() => setAction("cancel")}>Cancel</button>
      </div>
    </div>
  );
};

export default Dialog;
